import React from 'react';

import { Box } from '@hz-design-system/web-ui';
import { ListingDate, ListingPriority } from '@/client/components/ListingsNew/components';

import Classes from './ListingPirorityDateFeature.module.scss';

interface ListingPriorityDateFeatureProps {
  priorityProduct: string;
  date: string;
}

const ListingPriorityDateFeature: React.FC<ListingPriorityDateFeatureProps> = ({ priorityProduct, date }) => {
  return (
    <Box
      as="div"
      name="Listing-group-bottom-row-priority-and-date"
      className={Classes['hz-Listing-group-bottom-row-priority-and-date']}
    >
      <ListingPriority.Small priorityProduct={priorityProduct} />
      <ListingDate.Small date={date} />
    </Box>
  );
};

export default ListingPriorityDateFeature;
